export type Environment = "dev" | "qa" | "uat" | "prod";

export const ENVIRONMENT: Environment = (process.env.ENVIRONMENT as Environment) || "dev";
